<template>
    <div id="home" class="fill-height">
        <v-overlay absolute="" opacity="0.2" :value="loader">
            <v-progress-circular :color="appColor" indeterminate size="32"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar.status" top :color="snackbar.color" :timeout="snackbar.timeout">
            <v-icon class="mr-1">{{ snackbar.icon }}</v-icon> {{ snackbar.message }}
        </v-snackbar>
        <v-container>
            <welcome></welcome>
            <announcement :announcement="getAdminAnnouncement"></announcement>
            <statistics ref="statistics" :residenceBool="residenceBool" :residenceTerms="residenceTerms"
                :statistics="statistics" @refreshData="refreshData" @setResidenceBool="setResidenceBool">
            </statistics>
        </v-container>
    </div>
</template>

<script>
import Announcement from '../../components/Admin/Home/Announcement';
import Statistics from '../../components/Admin/Home/Statistics';
import Welcome from '../../components/Admin/Home/Welcome';

export default {
    name: 'home',
    components: {
        Announcement,
        Statistics,
        Welcome
    },
    data() {
        return {
            announcements: [],
            loader: true,
            refreshTimer: '',
            residenceBool: false,
            residenceTerms: [],
            snackbar: {
                color: 'success',
                icon: '',
                message: '',
                status: false,
                timeout: 5000
            },
            statistics: {},
        }
    },
    methods: {
        getHomeData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getHome`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Home dashboard data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    // Announcements
                    that.announcements = json.announcements ? json.announcements : that.announcements;

                    // Residence Terms
                    that.residenceTerms = json.residenceTerms ? json.residenceTerms : that.residenceTerms;

                    that.setLoader(false);
                })
                .catch(function () {
                    that.setLoader(false);
                })
        },
        getStatsData() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getStats&data={"type":"applicationStatus"}`;

            if (this.residenceBool) {
                let residenceTerm = this.$refs.statistics ? this.$refs.statistics.getResidenceTerm() : "";
                api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getStats&data={"term":"${residenceTerm}","type":"applicationStatus"}`
            }

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Check for application status
                    if (json.data && json.data[0]) {
                        that.statistics = json.data[0];
                    }

                    // Error handling
                    if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `Statistics data could not be retrieved. Please contact your system administrator.`, true);
                    }
                })
                .catch(function () {})
        },
        refreshData() {
            this.getHomeData();
            this.getStatsData();
        },
        setLoader(bool) {
            this.loader = bool;
        },
        setNotification(color, icon, message, status) {
            // Reset snackbar
            this.snackbar.status = false;

            // Set snackbar fields
            this.snackbar.color = color;
            this.snackbar.icon = icon;
            this.snackbar.message = message;
            this.snackbar.status = status;
        },
        setResidenceBool(bool) {
            this.residenceBool = bool;
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        },
        getAdminAnnouncement() {
            let announcement = {
                class: '',
                enabled: false,
                text: ''
            }

            for (let i = 0; i < this.announcements.length; i++) {
                if (this.announcements[i].hasOwnProperty('announcement-location') && this.announcements[i]['announcement-location'].match(/admin/gi)) {
                    announcement.class = this.announcements[i]['announcement-class'];
                    announcement.enabled = this.announcements[i]['active'] == "1" ? true : announcement.enabled;
                    announcement.text = this.announcements[i]['announcement'];
                }
            }

            return announcement;
        },
    },
    created() {
        this.refreshData();
        this.refreshTimer = setInterval(this.refreshData, 60000);
    },
    beforeDestroy() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    },
    destroyed() {
        // Clear refresh function
        clearInterval(this.refreshTimer);
    }
}
</script>